const addhttp = (url) => {
  const pattern = new RegExp("^https://")
  if (!pattern.test(url)) {
    url = "http://" + url
  }
  return url
}

export { addhttp }
